import {OnFailure, OnSuccess, OnSuccessData} from "../actionHelpers";
import {Dispatch} from "react-redux";
import {api} from "../../../api/api";
import {BILL_FETCHED, BILL_UPDATED, BILLS_FETCHED,} from "./actionType";
import Bill from "../../../model/bill/Bill";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";

/**
 * Bills fetched successful actiosaan.
 * @return {Action<BILLS_FETCHED>}
 * @param bills
 */
function billsFetched(bills: Bill[]) {
	return {type: BILLS_FETCHED, payload: {bills}};
}

/**
 * Bill fetched successful action.
 * @param bill
 * @return {Action<BILL_FETCHED>}
 */
function billFetched(bill: Bill) {
	return {type: BILL_FETCHED, payload: {bill}};
}

/**
 * Bill updated successful action.
 * @return {Action<BILL_UPDATED>}
 * @param bill
 */
function billUpdated(bill: Bill) {
	return {type: BILL_UPDATED, payload: {bill}};
}

/**
 * Fetch bills action.
 * @param partnerBrandId
 * @param {OnSuccess} onSuccess on successful fetch action callback.
 * @param {OnFailure} onFailure on failure action callback.
 */
export function fetchBills(partnerBrandId: string, onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.billApi.fetchBills(partnerBrandId).then(bills => {
			dispatch(billsFetched(bills));
			onSuccess();
		}).catch(onFailure);
	}
}

/**
 * Fetch bill action.
 * @param billId
 * @param {OnSuccess} onSuccess on successful fetch action callback.
 * @param {OnFailure} onFailure on failure action callback.
 */
export function fetchBill(billId: string, onSuccess: OnSuccessData<Bill>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.billApi.fetchBill(billId).then(bill => {
			dispatch(billFetched(bill));
			onSuccess(bill);
		}).catch(onFailure);
	}
}

/**
 * Fetch bill by job id action.
 * @param jobId
 * @param {OnSuccess} onSuccess on successful fetch action callback.
 * @param {OnFailure} onFailure on failure action callback.
 */
export function fetchBillByJobId(jobId: string, onSuccess: OnSuccessData<Bill>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.billApi.fetchBillByJobId(jobId).then(bill => {
			dispatch(billFetched(bill));
			onSuccess(bill);
		}).catch((error) => {
			if (error && error.response && error.response.status !== 404) {
				notifyBugsnagAndShowToast(error, "Fetch bill");
			}
			onFailure(error);
		});
	}
}

/**
 * Change pay via mobile flag action.
 * @param billId bill identifier
 * @param payViaMobile new flag value
 * @param {OnSuccess} onSuccess on successful fetch action callback.
 * @param {OnFailure} onFailure on failure action callback.
 */
export function updatePayViaMobileFlag(billId: string,
	payViaMobile: boolean,
	onSuccess: OnSuccess,
	onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.billApi.changePayViaMobile(billId, payViaMobile).then(bill => {
			dispatch(billUpdated(bill));
			onSuccess();
		}).catch(onFailure);
	}
}

/**
 * Change Bill dates.
 */
export function updateBill(bill: Bill,
	onSuccess: OnSuccess,
	onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.billApi.updateBill(bill).then(updatedBill => {
			dispatch(billUpdated(updatedBill));
			onSuccess();
		}).catch(onFailure);
	}
}
